import { render, staticRenderFns } from "./AdvSwitch.vue?vue&type=template&id=66610d47"
import script from "./AdvSwitch.vue?vue&type=script&lang=js"
export * from "./AdvSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports